import {Helmet} from 'react-helmet-async';
import {QueryClientProvider} from 'react-query';
import {RecoilRoot} from 'recoil';
import config from './config/config';
import Container from './components/Container/Container';
import Search from './components/Search/Search';
import {queryClient} from './services/queryClient';

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <RecoilRoot>
        <div className="App">
          <Helmet>
            <link rel="stylesheet" href={config?.cssFileAddress} />
          </Helmet>
          <Container>
            <Search />
          </Container>
        </div>
      </RecoilRoot>
    </QueryClientProvider>
  );
}

export default App;
